import React, { Component } from 'react';
import store from '../store';
import { HandleSubmit, CreateDownloadLink, HandleSubmitSendFile } from '../func/HandleSubmit'
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
class Backup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            DownloadPath: "",
            ShowLink: false,
            loading: false,
            OK: false,
            SendParameters: {
                'sqlfile': null,
                "sqlfilename": ""
            }
        }
    }

    SetParameterValue(name, value) {
        this.state.SendParameters = { ...this.state.SendParameters, [name]: value };
        this.setState({
            SendParameters: this.state.SendParameters,
        });
        console.log("this.state.SendParameters", this.state.SendParameters);
    }
    async GetBackup() {
        let response = await HandleSubmit('backup/getbackup', {});
        // console.log("GetBackup: ", response);
        if ((response).status === "OK") {
            //alert("OK SHOD");
            this.setState({
                DownloadPath: CreateDownloadLink(),
                ShowLink: true
            });
        }
    }
    async DeleteAll() {
        this.setState({ loading: true });
        let response = await HandleSubmit('backup/deleteall', {});
        console.log("DeleteAll", response);
        if ((response).status === "OK") {
            this.setState({ loading: false, OK: true });
            alert("با موفقیت انجام شد");
        }
    }
    async HandleRestore() {
        this.setState({ loading: true });
        let response = await HandleSubmitSendFile('backup/restorebackup', this.state.SendParameters);
        if ((response).status === "OK") {
            this.setState({ loading: false, OK: true });
            alert("با موفقیت بارگزاری شد");

        }
    }
    async componentDidMount() {
        store.dispatch({ type: 'backup' });
        //await this.Login();
    }
    render() {
        if (this.state.loading)
            return <h1>در حال بارگزاری اطلاعات</h1>
        if (this.state.OK)
            return <Redirect to='/' />
        return (
            <React.Fragment>
                {!this.state.ShowLink ?
                    <button className="btn btn-outline-warning" onClick={() => this.GetBackup()}>پشتیبان گیری</button>
                    :
                    <a href={this.state.DownloadPath} download name="ddddd">Click to download</a>
                }
                <br />
                <br />
                <div class="container">

                    <div class="row">
                        <div class="col-sm-4">
                        </div>
                        <div class="col-sm-auto">
                            <div className="border border-success">
                                <br />
                                انتخاب فایل
                                <input className="btn btn-outline-warning" type="file" id="fileid" name="fileList"
                                    onChange={(e) => (this.SetParameterValue('sqlfile', e.target.files[0]),
                                        this.SetParameterValue('sqlfilename', e.target.files[0].name)
                                        , console.log("e.target", e.target.files[0]))}
                                />
                                <br />
                                <br />
                                <button className="btn btn-outline-warning" onClick={() => this.HandleRestore()}>Restore</button>

                                <br />
                                <br />
                            </div>
                        </div>
                        <div class="col-sm-4">

                        </div>
                    </div>
                    <div class="row">
                        <br />
                        <br />
                        <div className="border border-success">
                            <br />
                            <ConfirmBox func={() => this.DeleteAll()} />
                            <br />
                        </div>
                    </div>

                </div>
            </React.Fragment>
        );
    }
}
export default Backup;

class ConfirmBox extends React.Component {
    constructor(props) {
        super(props);
        this.func = this.props.func.bind(this);
    }
    submit = () => {
        confirmAlert({
            title: 'حذف',
            message: 'آیا اطمینان دارید؟',
            buttons: [
                {
                    label: 'بله',
                    onClick: () => this.func()
                },
                {
                    label: 'خیر',
                    // onClick: () => alert('Click No')
                }
            ]
        });
    };
    render() {
        return (
            <div className='container'>
                <button className="btn btn-outline-danger" onClick={this.submit}>حذف کلیه اطلاعات سفارش ها</button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/backup/Backup.js